<template>
  <div
    class="p-contact-list-placeholder"
    data-test-id="contact-list-placeholder"
  >
    <span class="el-text el-text--body-24 el-text--white-space-pre-line">
      {{ $t('profile.contact-list.placeholder') }}
    </span>
    <ul>
      <li>{{ $t('profile.contact-list.placeholder.launches') }}</li>
      <li>{{ $t('profile.contact-list.placeholder.features') }}</li>
      <li>{{ $t('profile.contact-list.placeholder.promotions') }}</li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'ContactListPlaceholder'
};
</script>

<style lang="scss" scoped>
.p-contact-list-placeholder {
  padding: 16px 24px;
}
</style>
